import {Injectable} from '@angular/core';
import {Capacitor} from "@capacitor/core";
import { Storage } from '@capacitor/storage';

@Injectable()
export class StorageService {
  constructor() {

  }

  get(key): Promise<any> {
    const {Storage} = Capacitor.Plugins;
    return new Promise((resolve, reject) => {
      Storage.get({key:key}).then(({value}: any) => {
        resolve(JSON.parse(value));
      });
    });
  }

  set(key, value): Promise<any> {
    //const {Storage} = Capacitor.Plugins;
    return Storage.set({key:key, value: JSON.stringify(value)});
  }
}



// WEBPACK FOOTER //
// ./src/app/services/storage.service.ts